export const fieldPropertiesActionType = {
  addFieldProperties: "AddFieldProperties",
  removeFieldProperties: "RemoveFieldProperties",
  editFieldProperties: "EditFieldProperties",
};
